import React from "react";
import NavBar from "./NavBar";

function Layout({ children }) {
  return (
    <>
      <NavBar content={children} />
    </>
  );
}

export default Layout;
